export default "__VITE_ASSET__7vd8oUyk__"